__turbopack_context__.v({
  "root": "r2qYwq_root",
});
